import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Card, CardContent, Grid, makeStyles, Typography } from '@material-ui/core';
import clsx from 'clsx';
const useStyles = makeStyles((theme) => ({
    card: {
        borderRadius: 6,
    },
    bannerIconCard: {
        alignItems: 'center',
        backgroundColor: theme.palette.brand.feather,
        border: 'none',
        borderRadius: 6,
        display: 'flex',
        justifyContent: 'center',
        width: 150,
        height: 150,
        '& svg': {
            height: 75,
            width: 'auto',
        },
    },
    bannerDescription: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(2),
    },
    disableBtn: {
        borderColor: theme.palette.error.main,
        color: theme.palette.error.main,
        '&:hover': {
            backgroundColor: 'transparent',
            borderColor: theme.palette.error.light,
        },
    },
    bannerContent: {
        padding: theme.spacing(3),
    },
    bannerDetails: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
}));
export const IntegrationBanner = ({ description, enabled, icon, onClick, title }) => {
    const classes = useStyles();
    return (_jsx(Card, { variant: 'outlined', className: classes.card, children: _jsx(CardContent, { className: classes.bannerContent, children: _jsxs(Grid, { container: true, spacing: 3, children: [_jsx(Grid, { item: true, children: _jsx(Card, { className: classes.bannerIconCard, variant: 'outlined', children: icon && icon }) }), _jsx(Grid, { item: true, className: classes.bannerDetails, children: _jsxs("div", { children: [_jsx(Typography, { variant: 'h2', children: title }), _jsx(Typography, { variant: 'body1', className: classes.bannerDescription, children: description }), _jsx(Button, { className: clsx(enabled && classes.disableBtn), color: 'primary', variant: enabled ? 'outlined' : 'contained', size: 'small', onClick: onClick, children: enabled ? 'Disable' : 'Enable' })] }) })] }) }) }));
};
